/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { createFilterStateSelector } from '../create-filter-state-selector/create-filter-state.selector';

export const CreateAllDataSelector = (filterInstanceId: string) =>
  createSelector(
    createFilterStateSelector(filterInstanceId),
    (filterState) => filterState?.dataToFilter ? Object.values(filterState.dataToFilter) : null
  );
